import Eula from './eula';

export default Eula;
